export default __webpack_public_path__ + "static/spotify_services-0092c6ede189bea926ed6ea1df13f176.png";